import { InsuranceCompanyOfferContent } from './InsuranceCompanyOfferContent';

const defaultValueFormFields = {
  companyName: '',
  costCoverageConditionAccepted: false,
  courseParticipationLimitAccepted: false,
  personalDataConditionAccepted: false,
  postalCodeCheck: false
};

export const InsuranceCompanyOffer = (data) => {
  let formFields = {};
  let optionalFields = {};
  let offerContent = {};

  if (data?.content) {
    const { formFields: _formFields, optionalFields: _optionalFields, ...content } = InsuranceCompanyOfferContent(data.content);
    formFields = _formFields;
    offerContent = content;
    optionalFields = _optionalFields;
  }

  const defaultValues = {};

  Object.keys(formFields).forEach((key) => {
    if (defaultValueFormFields[key] !== undefined) {
      defaultValues[key] = defaultValueFormFields[key];
    }
  });

  const form = {
    offerId: data?.offerId || null,
    key: data?.slug || null,
    fields: formFields,
    optionalFields,
    defaultValues
  };

  return {
    id: data.id || null,
    title: data.courseTitle || '',
    cooperationKey: data.cooperationKey || null,
    slug: data.slug || null,
    form,
    // ToDo: currently waiting for backend to provide contentAccessDuration
    contentAccessDuration: 6,
    // ToDo: currently waiting for backend to provide timeToComplete
    timeToComplete: 6,
    content: offerContent || {},
    checkoutContent: {
      accessDurationText: data?.content?.bonusDurationText || ''
    },
    cooperationLogo: data.cooperationLogo || null,
    cooperationLogoHover: data.cooperationLogoHover || null,
    cooperationPartner: data.cooperationPartner || null,
    reductionRate: data.reductionRate || 0
  };
};
